import * as yup from "yup";

export const FLEET_VEHICLE_REGISTRATION_FORM_SCHEMA = yup.object().shape({
    registrationPlate: yup
        .string()
        .required("Molimo Vas da unesete registracijsku oznaku"),
    registrationExpiration: yup
        .date()
        .required("Molimo Vas da unesete datum isteka registracije")
        .typeError("Molimo Vas da unesete valjani datum"),
});